import { Badge } from "@/components/ui/badge";
import { ScrollArea } from "@/components/ui/scroll-area";
import { ChevronsDown } from "lucide-react";

interface CharacterPreviewPanelProps {
  characters: string[];
  language: string;
  additionalSets: string[];
}

export default function CharacterPreviewPanel({
  characters,
  language,
  additionalSets,
}: CharacterPreviewPanelProps) {
  return (
    <div className="flex flex-col h-full">
      {/* Summary */}
      <div className="flex items-center justify-between mb-4">
        <h4 className="text-sm font-medium text-gray-700">Character Set</h4>
        <Badge variant="secondary" className="text-sm">
          {characters.length} characters
        </Badge>
      </div>

      {/* Character Grid with Scroll - Takes remaining height */}
      <div className="flex-1 bg-gray-50 rounded-lg border border-gray-200 p-4 overflow-hidden relative">
        <div className="flex items-center justify-between mb-3">
          <h4 className="text-sm font-medium text-gray-700">Selected Characters</h4>
          {characters.length > 48 && (
            <div className="flex items-center gap-1 text-xs text-gray-500">
              <ChevronsDown className="h-3 w-3 animate-bounce" />
              <span>Scroll for more</span>
            </div>
          )}
        </div>
        {characters.length > 0 ? (
          <div className="relative h-[calc(100%-2rem)]">
            <ScrollArea className="h-full">
              <div className="grid grid-cols-8 gap-2 pr-4">
                {characters.map((char, index) => (
                  <div
                    key={index}
                    className="flex items-center justify-center h-10 w-10 bg-white border border-gray-200 rounded text-sm font-medium hover:border-purple-300 transition-colors"
                    title={char === " " ? "Space" : char}
                  >
                    {char === " " ? "␣" : char}
                  </div>
                ))}
              </div>
            </ScrollArea>
            {/* Fade indicator at bottom */}
            {characters.length > 48 && (
              <div className="absolute bottom-0 left-0 right-0 h-12 bg-gradient-to-t from-gray-50 to-transparent pointer-events-none" />
            )}
          </div>
        ) : (
          <p className="text-sm text-gray-500 text-center py-8">
            Select a language and character sets to preview
          </p>
        )}
      </div>
    </div>
  );
}

